<template>
  <!-- SMART MENU ( full screen overflow and mobile) -->
  <div
    v-if="customisation"
    :class="[
      customisation.layout === 0 ? 'layout-0' : '',
      customisation.menu === 0 ? 'menu-0' : '',
      customisation.menu === 1 ? 'menu-1' : '',
      activeMenuSlide === 'admin'
        ? 'bg-truegray-700 text-white'
        : 'bg-truegray-100',
    ]"
    class="h-screen z-90 menu-container fixed top-0 right-0 flex flex-col items-center"
  >
    <div
      :style="[{ width: '90%' }, { height: '64px' }]"
      class="bg-truegrey-100 ml-auto border-b-2 border-truegrey-300 z-20"
    ></div>
    <div
      :class="[
        customisation.layout === 0 ? 'layout-0' : '',
        customisation.menu === 0 ? 'menu-0' : '',
        customisation.menu === 1 ? 'menu-1' : '',
      ]"
      class="menu-nav-container flex justify-between px-6 p-8 lg:p-16 lg:pb-0 fixed top-16 lg:top-8 right-0 z-50"
    >
      <div class="flex flex-col space-y-2">
        <div
          v-if="user && activeMenuSlide != 'admin'"
          class="btn btn-black cursor-pointer h-8 m-0"
          @click="openAdminPanel"
        >
          Admin Panel
        </div>
        <div
          v-if="activeMenuSlide != 'main'"
          :class="activeMenuSlide === 'admin' ? 'text-white' : ''"
          class="flex items-center lg:justify-center justify-start uppercase cursor-pointer text-center m-0"
          @click="goToMainMenuSlide"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
          <h3 class="text-base m-0">Back to main menu</h3>
        </div>
      </div>
      <button
        type="button"
        :class="
          activeMenuSlide === 'admin'
            ? 'hover:text-truegray-300'
            : 'hover:text-primary'
        "
        class="ml-auto transform hover:rotate-180 transition-all duration-300 hover:text-primary z-50 m-0"
        @click="closeMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>

    <div class="flex flex-col items-center justify-center w-full">
      <!-- Main panel -->
      <div
        id="menuMain"
        :style="[{ paddingTop: '12vh' }, { margin: '4rem 0' }]"
        :class="
          activeMenuSlide === 'main'
            ? 'opacity-100 translate-y-0'
            : 'translate-y-full opacity-0 pointer-events-none'
        "
        class="absolute left-0 top-0 w-full h-full flex space-x-4 transition-all duration-500 transform px-6 mb-12 overflow-scroll z-10"
      >
        <div class="w-full flex flex-col items-center">
          <div
            :class="customisation.layout !== 2 ? 'lg:flex-nowrap' : ''"
            class="flex w-full flex-wrap"
          >
            <div
              :class="[
                menu.length > 0 && customisation.layout !== 2
                  ? 'lg:w-1/2 lg:pr-12 lg:justify-end'
                  : '',
              ]"
              class="w-full justify-center"
            >
              <!-- Default pages -->
              <h2
                :class="[
                  menuItemClass,
                  menu.length > 0 && customisation.layout !== 2
                    ? 'lg:text-right'
                    : '',
                  activeMenuItem === 'Home' ? 'text-primary' : '',
                ]"
                @click="pushRoute('Home')"
              >
                Home
              </h2>
              <h2
                v-if="settings.enabled_contact"
                :class="[
                  menuItemClass,
                  menu.length > 0 && customisation.layout !== 2
                    ? 'lg:text-right pb-8'
                    : '',
                ]"
                class="hidden lg:block"
                @click="contact()"
              >
                Contact
              </h2>
            </div>
            <div
              v-if="menu.length > 0"
              :class="
                customisation.layout !== 2 ? 'lg:w-1/2 lg:justify-start' : ''
              "
              class="w-full justify-center space-y-3"
            >
              <!-- Dynamic pages -->
              <div
                v-for="(parent, i) in filteredMenu"
                :key="i"
                :ref="'menu-item' + i"
                class="menu-item"
                :class="[
                  i + 1 === menu.length && !settings.enabled_contact
                    ? 'pb-8'
                    : '',
                  activeMenuItem === parent.id ? 'text-primary' : '',
                ]"
              >
                <div
                  v-if="parent.children.length >= 1"
                  class="hover:text-primary"
                >
                  <div
                    :class="
                      customisation.layout !== 2 ? 'lg:justify-start' : ''
                    "
                    class="space-x-2 w-full text-center flex items-center justify-center"
                    @click="setActiveSlide(parent.id)"
                  >
                    <p
                      :class="customisation.layout !== 2 ? 'lg:text-left' : ''"
                      class="text-center text-lg font-primary hover:text-primary cursor-pointer"
                    >
                      {{ parent.title }}
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 flex-shrink-0"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                </div>

                <div
                  v-else
                  :class="customisation.layout !== 2 ? 'lg:justify-start' : ''"
                  class="space-x-2 w-full text-center flex items-center justify-center"
                  @click="pushToPageRoute(parent)"
                >
                  <svg
                    v-if="parent.page_type === 1"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-3 w-3 opacity-50"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                  <p
                    class="text-center lg:text-left text-lg font-primary hover:text-primary cursor-pointer"
                  >
                    {{ parent.title }}
                  </p>
                </div>
              </div>

              <p
                v-if="settings.enabled_contact"
                class="lg:hidden block text-center text-lg font-primary hover:text-primary cursor-pointer pb-8"
                @click="contact()"
              >
                Contact
              </p>
            </div>
          </div>

          <div v-if="customisation.layout !== 2" class="pb-16 mt-12">
            <button
              class="btn btn-primary rounded-lg w-40 h-12"
              @click="showSubscribeModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                />
                <path
                  d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                />
              </svg>
              <span>Subscribe</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Children panels -->
      <div
        v-for="(parent, i) in dropdownParents"
        :key="i"
        :style="[{ paddingTop: '96px' }, { margin: '64px 0' }]"
        :class="
          activeMenuSlide === parent.id
            ? 'opacity-100 translate-y-0'
            : 'translate-y-full opacity-0 pointer-events-none'
        "
        class="absolute left-0 top-0 w-full h-full flex lg:flex-row flex-col space-y-4 lg:space-y-0 lg:space-x-4 transition-all duration-500 transform px-6 mb-12 z-10 overflow-scroll"
      >
        <div class="w-full lg:w-1/2">
          <h4
            v-if="parent.title"
            class="border-b lg:border-b-0 lg:pb-0 pb-4 border-primary text-primary text-center lg:text-right font-bold text-base uppercase flex justify-center lg:justify-end"
          >
            {{ parent.title }} <span class="mx-2 hidden lg:block">|</span>
          </h4>
        </div>

        <div class="w-full lg:w-1/2">
          <p
            v-if="parent.page_type !== 2 && !parent.static"
            class="text-center lg:text-left text-lg font-primary hover:text-primary cursor-pointer"
            @click="pushToPageRoute(parent)"
          >
            {{ parent.title }}
          </p>
          <div v-for="(child, j) in parent.children" :key="j" class="mb-2">
            <!-- NORMAL CHILDREN -->
            <p
              v-if="!child.postsPage"
              class="text-center lg:text-left text-lg font-primary hover:text-primary cursor-pointer"
              :class="{
                'text-primary font-bold':
                  activeMenuItem === child.id ||
                  child.title.toLowerCase() ==
                    (typeof activePostsItem === 'string'
                      ? activePostsItem.toLowerCase()
                      : ''),
              }"
              @click="pushToPageRoute(child)"
            >
              {{ child.title }}
            </p>
            <!-- POSTS OBJECT MANUAL UNSHIFTED ITEMS -->
            <p
              v-else
              class="text-center lg:text-left text-lg font-primary hover:text-primary cursor-pointer"
              @click="pushToPosts(child.postsRoute)"
            >
              {{ child.title }}
            </p>
          </div>
        </div>
      </div>

      <!-- Admin panel -->
      <div
        v-if="user"
        :style="[{ paddingTop: '96px' }, { margin: '64px 0' }]"
        :class="
          activeMenuSlide === 'admin'
            ? 'opacity-100 translate-y-0'
            : 'translate-y-full opacity-0 pointer-events-none'
        "
        class="absolute left-4 top-0 w-full h-full flex lg:flex-row flex-col space-y-4 lg:space-y-0 lg:space-x-4 transition-all duration-500 transform px-6 mb-12 z-10 overflow-scroll"
      >
        <div class="w-full">
          <h2
            class="font-normal lg:font-bold text-lg lg:text-h2 font-primary text-white cursor-pointer smart-menu-admin-text"
          >
            Admin Panel
          </h2>
          <h2
            v-if="user?.admin_user"
            :class="[
              adminMenuItemClass,
              isMenuItemLocked('New Post', settings)
                ? 'cursor-not-allowed'
                : 'cursor-pointer',
            ]"
            @click="triggerManagerMenuItem('New Post')"
          >
            New Post
            <svg
              v-if="isMenuItemLocked('New Post', settings)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              class="w-4 h-4 ml-2"
            >
              <path
                fill-rule="evenodd"
                d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                clip-rule="evenodd"
              />
            </svg>
          </h2>
          <h2
            v-for="(item, i) in menuItems"
            :key="i"
            :class="[
              adminMenuItemClass,
              isMenuItemLocked(item.name, settings)
                ? 'cursor-not-allowed'
                : 'cursor-pointer',
              activeAdminMenuItem === item.name ? 'text-primary' : '',
            ]"
            @click="triggerManagerMenuItem(item.name)"
          >
            {{ item.title || item.name }}
            <span v-if="isMenuItemLocked(item.name, settings)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="w-4 h-4 ml-2"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </h2>
          <h2
            v-if="user?.admin_user"
            class="flex cursor-pointer items-center justify-center"
            @click="triggerManagerMenuItem('Hootmail')"
          >
            <div class="hootmail relative w-6">
              <div
                v-if="updatesRequiredCount"
                class="hootmail-count absolute p-1 bg-cw-alt rounded-full text-white border-2 border-white flex items-center"
              >
                <div class="relative group text-xs">
                  {{ updatesRequiredCount }}
                </div>
              </div>
              <img class="w-6" src="/img/logo-cw.png" alt="CareerWise logo" />
            </div>
            <h2 class="ml-4 mb-0" :class="adminMenuItemClass">Hootmail</h2>
          </h2>
          <h2 :class="adminMenuItemClass">
            <a
              :class="adminMenuItemClass"
              class="no-underline"
              href="https://careerwise.helpscoutdocs.com/category/164-all-articles"
              target="_blank"
              >Knowledge Base</a
            >
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../../js/plugins/event-bus.js'
import { shared } from '../../../../js/mixins/shared.js'
import { mapGetters } from 'vuex'
import {
  isMenuItemLocked,
  scrollToElement,
} from '../../../../js/util/helper.js'

export default {
  mixins: [shared],

  data() {
    return {
      activeMenuItem: 'Home',
      activeDropDownItem: null,
      activePostsItem: null,
      activeMenuParent: null,
      activeMenuSlide: 'main',
      dropdownsFound: false,
      dropdownParents: null,
      activeAdminMenuItem: null,
      menuItems: [
        {
          name: 'Cloud',
        },
        {
          name: 'Drafts',
        },
        {
          name: 'Settings',
        },
        {
          name: 'Mail',
        },
        {
          name: 'Connections',
        },
        {
          name: 'Pages',
        },
        {
          name: 'Library',
        },
        {
          name: 'Resources',
          title: 'Media',
        },
        {
          name: 'Analytics',
        },
        {
          name: 'Automations',
        },
      ],

      // Add non dynamic page object for posts. Id is 0 for no conflicts. Lean into - numbers if more need adding.
      connectionsObject: {
        title: 'Connections',
        id: -1,
        external_link: false,
        status: 1,
        page_type: 99,
        children: [],
        route: 'connections',
      },

      // Static true changes the parent appearing in the dropdown container
      postsObject: {
        title: 'Posts',
        id: 0,
        external_link: false,
        status: 1,
        page_type: 99,
        static: true,
        children: [
          {
            title: 'News',
            external_link: false,
            page_type: 99,
            status: 1,
            postsPage: true,
            postsRoute: 'news',
          },
          {
            title: 'Events',
            external_link: false,
            page_type: 99,
            status: 1,
            postsPage: true,
            postsRoute: 'events',
          },
          {
            title: 'Jobs',
            external_link: false,
            page_type: 99,
            status: 1,
            postsPage: true,
            postsRoute: 'jobs',
          },
        ],
      },

      adminMenuItemClass:
        'font-normal text-lg lg:text-h3 font-primary text-white text-center hover:text-truegray-300 flex items-center justify-center',
      matomo_id_found: false,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      user: 'shared/getUser',
      menu: 'shared/getMenu',
      customisation: 'careerwise/getCustomisation',
      updatesRequiredCount: 'careerwise/getUpdatesRequiredCount',
    }),

    filteredMenu() {
      let menu = this.menu
        .filter((item) => item.status === 1)
        .map((item) => ({
          ...item,
          children: item.children.filter((child) => child.status === 1),
        }))

      // Add non dynamic page object for posts. Id is 0 for no conflicts. Lean into - numbers if more need adding.
      // Static true changes the parent appearing in the dropdown container
      // Add new object to the beginning of the array

      menu.unshift(this.connectionsObject)
      menu.unshift(this.postsObject)

      return menu
    },

    menuItemClass() {
      if (this.customisation.layout === 2) {
        return 'font-normal text-lg font-primary text-black text-center hover:text-primary cursor-pointer'
      }
      return 'font-normal lg:font-bold text-lg lg:text-h2 lg:font-primary lg:text-truegray-500 text-center hover:text-primary cursor-pointer'
    },
  },

  watch: {
    $route: {
      immediate: true,

      handler(to) {
        if (!to.path.includes('/manager')) {
          this.activeAdminMenuItem = null
        }

        if (to.name === 'Home') {
          this.activeMenuItem = 'Home'
          this.activePostsItem = null
        } else if (to.path.includes('/page/')) {
          const idString = to.path.split('/').pop()
          const id = Number(idString)
          this.activeMenuItem = id
          this.activePostsItem = null

          // Find the page with the id of activeMenuItem
          const page =
            this.filteredMenu.find((parent) => parent.id === id) ||
            this.filteredMenu
              .flatMap((parent) => parent.children)
              .find((child) => child.id === id)

          // Set activeMenuParent to parent_id if it exists
          if (page && page.parent_id) {
            this.activeMenuParent = Number(page.parent_id)
          } else {
            this.activeMenuParent = null
          }
        } else if (to.path.includes('/posts')) {
          this.activeMenuItem = 0
          if (to.query.category) {
            this.activePostsItem = to.query.category
          }
        } else {
          this.activeMenuItem = null
          this.activePostsItem = null
        }
      },
    },
  },

  mounted() {
    //check if tracking id has been applied to the tenant
    let id = document.getElementsByTagName('body')[0].dataset.matomo_tracking
    if (id) {
      this.$set(this, 'matomo_id_found', true)
    }

    this.findDropdownMenuItems()

    EventBus.$on('openAdminMenu', () => {
      this.openAdminPanel()
    })
  },

  methods: {
    isMenuItemLocked,

    pushToPosts(type) {
      if (this.$router.history.current.name === 'Posts') {
        const currentRoute = this.$router.currentRoute
        const desiredPath = '/posts'
        const desiredType = type
        const currentType = currentRoute.query.category

        if (currentRoute.path !== desiredPath || currentType !== desiredType) {
          const updatedQuery = { ...currentRoute.query, category: desiredType }
          this.$router.replace({ ...currentRoute, query: updatedQuery })
        }
      } else {
        this.$router.push({
          path: '/posts?category=' + type,
          params: { type: type },
        })
      }
      EventBus.$emit('posts_params_changed')
      EventBus.$emit('modal_state_changing', false)
      EventBus.$emit('showSmartMenu', false)
      EventBus.$emit('closeResourceModals')
      this.$set(this, 'activeMenuSlide', 'main')
    },

    pushRoute(route) {
      if (route === 'Posts' && this.$router.currentRoute.name === route) {
        EventBus.$emit('NonManagerRouteClicked')
        EventBus.$emit('toggleMenu')
        EventBus.$emit('reload_posts_to_published')
      }
      if (this.$router.currentRoute.name !== route) {
        EventBus.$emit('NonManagerRouteClicked')
        EventBus.$emit('toggleMenu')
        this.$router.push({ name: route })
      }
      EventBus.$emit('closeMobileMenu')
      EventBus.$emit('modal_state_changing', false)
      EventBus.$emit('showSmartMenu', false)
      EventBus.$emit('closeResourceModals')
      this.$set(this, 'activeMenuSlide', 'main')
    },

    pushToPageRoute(item) {
      let url = item.external_link
      if (item.external_link && this.validateURL(url)) {
        if (!this.validateURLProtocol(url)) {
          url = this.updateURLWithProtocol(url)
        }
        window.open(url, '_blank')
        return
      }
      let id = item.id
      EventBus.$emit('NonManagerRouteClicked')
      if (item.postsPage) {
        this.pushToPosts(item.postsRoute)
      } else if (item.route) {
        this.$router.push({ path: '/' + item.route })
      } else {
        this.$router.push({ path: '/page/' + id })
      }
      EventBus.$emit('closeMobileMenu')
      EventBus.$emit('modal_state_changing', false)
      EventBus.$emit('showSmartMenu', false)
      EventBus.$emit('closeResourceModals')
    },

    showFullMenu() {
      EventBus.$emit('showSmartMenu')
    },

    goToMainMenuSlide() {
      this.$set(this, 'activeMenuSlide', 'main')
    },

    findDropdownMenuItems() {
      let parentItems = []
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].children.length > 0) {
          parentItems.push(this.menu[i])
        }
        parentItems.unshift(this.postsObject)
        if (i + 1 === this.menu.length) {
          this.$set(this, 'dropdownParents', parentItems)
          this.$set(this, 'dropdownsFound', true)
        }
      }
    },

    setActiveSlide(id) {
      this.$set(this, 'activeMenuSlide', id)
    },

    closeMenu() {
      this.$set(this, 'activeMenuSlide', 'main')
      EventBus.$emit('showSmartMenu', false)
      EventBus.$emit('modal_state_changing', false)
    },

    showSubscribeModal() {
      EventBus.$emit('showModal', 'subscribe')
      this.closeMenu()
    },

    openNewPost() {
      EventBus.$emit('showModal', 'new-post')
      this.closeMenu()
    },

    triggerManagerMenuItem(item = '') {
      // Don't allow routing to a locked area
      if (this.isMenuItemLocked(item, this.settings)) {
        return
      }

      if (item === 'New Post') {
        this.openNewPost()
        return
      }

      this.$set(this, 'activeAdminMenuItem', item)

      item = item === 'Connections' ? 'ManagerConnections' : item
      if (this.$router.currentRoute.name !== item) {
        this.$router.push({ name: item })
      }

      this.closeMenu()
    },

    openAdminPanel() {
      this.$set(this, 'activeMenuSlide', 'admin')
    },

    contact() {
      if (this.customisation.layout === 2) {
        if (this.$router.history.current.name !== 'Home') {
          // If not, navigate to the home page
          this.$router.push({ path: '/' }).then(() => {
            // Wait for the navigation to complete before calling helper function
            // also allow some time for the posts to come back to stop dom shift
            // @todo do this better or adjust value once prod speeds can be tested
            setTimeout(() => {
              scrollToElement('contactForm')
            }, 700)
          })
        } else {
          // If we are already on the home page, just call helper function
          scrollToElement('contactForm')
        }
        this.closeMenu()
      } else {
        EventBus.$emit('showModal', 'contact')
        EventBus.$emit('closeMobileMenu')
        EventBus.$emit('showSmartMenu', false)
      }
    },
  },
}
</script>

<style scoped>
.menu-container,
.menu-nav-container {
  width: 100vw;
}

@media screen and (min-width: 1024px) {
  .menu-container.layout-0.menu-0,
  .menu-nav-container.layout-0.menu-0 {
    width: calc(100vw - 14rem);
  }

  .menu-container.layout-0.menu-1,
  .menu-nav-container.layout-0.menu-1 {
    width: calc(100vw - 4rem);
  }
}

.smart-menu-admin-text {
  font-size: 80px;
  color: #fff;
  opacity: 0.05;
  position: absolute;
  bottom: 10%;
  right: 5%;
}

.hootmail {
  overflow: visible;
}

.hootmail-count {
  height: 20px;
  width: 20px;
  top: -10px;
  right: -10px;
}
</style>
